import decimalCurrencyToSmallestUnit from '@/utils/decimalCurrencyToSmallestUnit';

/**
 * Calculates the price to send to Affirm. Affirm then calculates the monthly payment amount.
 *
 * @param discountedPrice - The final price after discount is applied (0 if no discount)
 * @param originalPrice - The original product price before any discounts
 * @returns The price in the smallest currency unit (e.g., cents for USD)
 */
const getAffirmPrice = (
  discountedPrice: number,
  originalPrice: number,
): number => {
  const price = discountedPrice || originalPrice;

  return decimalCurrencyToSmallestUnit(price);
};

export default getAffirmPrice;
